import React, { useContext, useEffect, useRef, useState } from "react";
// import QRCode from "qrcode.react";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import styles from "../../src/assets/sass/arViewer.module.sass";
import CurrentContext from "../utils/CurrentContext";
import { ModalViewer } from "../pages/smartobjectviewer";
import { CONFIGURATOR_UUID } from "../helpers/configData";
// import { getCurrentProductThumbnail } from "../utils/jsHelper";

export default function ARViewer() {
  const [isDesktop, setIsDesktop] = useState(false);
  const { setLoading, ARModelSrc, ARUnicode, isARReady, setIsARReady } =
    useContext(CurrentContext);
  const [arSrc, setArSrc] = useState(null);
  const { token } = useParams();
  const btnRef = useRef();
  const modRef = useRef();

  const isDesktopRef = useRef();
  const { uuid } = useParams();

  useEffect(()=>{
    if (CONFIGURATOR_UUID.includes(uuid)) {
      console.log("Configurator UUID - No AR");
      return;
    }
  },[])

  useEffect(() => {
    if (!ARModelSrc) return;
    setArSrc(ARModelSrc);
  }, [ARModelSrc]);

  const fetchArFile = () => {
    return new Promise((resolve, reject) => {
      const unicode = token || ARUnicode;
      if (!unicode) {
        reject(new Error("Token or ARUnicode is missing"));
        return;
      }

      setLoading(true);

      const unicodeApiUrl =
        "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/?unicode=" +
        unicode;

      fetch(unicodeApiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch AR file");
          }
          return response.json();
        })
        .then((data) => {
          console.log("DEBUG__finalData", {
            token,
            ARUnicode,
            fileFetchedViaUnicode: data,
            unicodeApiUrl,
            arSrc,
            isARReady,
            ARModelSrc,
            ARUnicode,
            url: `${window.location.origin}/ar/preview/${token || ARUnicode}`,
          });
          setArSrc(data?.data?.file);
          if (isDesktopRef?.current) setLoading(false);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  useEffect(() => {
    const userAgent = navigator?.userAgent;
    if (userAgent) {
      const flag =
        !/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
          userAgent
        );
      setIsDesktop(flag);

      isDesktopRef.current = flag;
    }
    // if (CONFIGURATOR_UUID.includes(uuid)) {
    //   console.log("Configurator UUID - No AR");
    //   return;
    // }else{
    //   fetchArFile();
    // }
  }, []);

  return (
    <div
      className={styles.arContainer}
      style={
        token
          ? {
              height: "100dvh",
              padding: "1.5rem",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
            }
          : {}
      }
    >
      {isDesktop ? <h2 className={styles.title}>View in Your Space</h2> : null}
      {isDesktop ? (
        <div className={styles.innerContainer}>
          <p className={styles.text}>
            Scan the QR code with the camera app on your mobile device.
          </p>
          <QRCode
            value={`${window.location.origin}/ar/preview/${token || ARUnicode}`}
            size={185}
            level="Q"
          />
        </div>
      ) : (
        <>
          {arSrc ? (
            <ModalViewer
              url={arSrc}
              setUrl={setArSrc}
              setLoading={setLoading}
            />
          ) : null}
         

          {arSrc && ARUnicode ? (
            <a
              href={`${window.location.origin}/ar/preview/${ARUnicode}`}
              target="_blank"
              style={{
                textDecoration: "none",
                cursor: "pointer",
                color: "#000",
                margin: "1rem auto 0",
                width: "auto",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: "#f2f2f2",
                border: "1px solid #e0e0e0",
                borderRadius: 16,
                boxShadow: "0px 0px 4px 1px rgba(140, 140, 140, 0.25)",
              }}
            >
              <img width={16} src="/icons/btn_AR.svg" alt="export gltf" />
              <span>View in Your Space</span>
            </a>
          ) : null}
        </>
      )}
    </div>
  );
}
